<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Name" style="text-align: left;">
          <b-input v-model="name" v-focus placeholder="The tournament's name" required></b-input>
        </b-field>

        <b-field label="Organizer" style="text-align: left;">
          <b-input v-model="organizer" placeholder="The tournament's organizer" required></b-input>
        </b-field>

        <b-field label="Number of courts" style="text-align: left;">
          <b-select v-model="numCourts" placeholder="Select..." expanded required>
            <option :value="val" v-for="val in 10">{{val}}</option>
          </b-select>
        </b-field>

        <b-field label="Match interval (minutes)" style="text-align: left;">
          <b-select v-model="matchIntervalMinutes" placeholder="Select..." expanded required>
            <option :value="(val*5)" v-for="val in 6">{{val*5}}</option>
          </b-select>
        </b-field>


        <b-field label="Tournament date" style="text-align: left;">
          <b-datepicker v-model="startTime" placeholder="Click to select..." icon="calendar-check" icon-pack="fas"
                        required :date-formatter="dateFormatter">
          </b-datepicker>
        </b-field>



          <b-field label="Import tournament data" style="text-align: left; margin-top: 40px;">
            <b-select v-model="importTournament" placeholder="Select..." expanded required>
              <option value="-1">Don't import existing data</option>
              <option :value="t.id" v-for="t in tournaments">{{ t.name }}</option>
            </b-select>
          </b-field>


          <b-field label="Data to import" style="text-align: left; margin-top: 40px;" v-if="importTournament != '-1'">
            <b-select v-model="importType" placeholder="Select..." expanded required>
              <option value="entries">Entries only (players and teams)</option>
              <option value="full">Entries and draws</option>
            </b-select>
          </b-field>


        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">{{(!id ? 'Create tournament' : 'Submit updates')}}</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';

export default {

  data: function() {
    return {
      name: '',
      organizer: '',
      numCourts: null,
      matchIntervalMinutes: null,
      startTime: null,

      importTournament: -1,
      importType: 'entries',

      submitInProgress: false,
      failedSubmit: false
    }
  },

  computed: {
    tournaments: function(){ return this.$store.state.tournaments; },
    id: function() { return this.$route.params.tournament; }
  },

  created: function(){
    if (this.tournaments && this.id) {
      let tournament = this.tournaments.filter(t => t.id == this.id);
      if (tournament && tournament.length > 0) {
        this.name = tournament[0].name;
        this.organizer = tournament[0].organizer;

        this.numCourts = tournament[0].numCourts;
        this.matchIntervalMinutes = tournament[0].matchIntervalMinutes;
        this.startTime = new Date(tournament[0].startTimeReal);
      }
    }
  },


  methods: {
    dateFormatter: function(date) {
      return date.toJSON().slice(0,10);
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      axios.post('/api/tournaments', {
        name: this.name,
        importType: this.importType,
        importTournament: this.importTournament,

        organizer: this.organizer,
        numCourts: this.numCourts,
        matchIntervalMinutes: this.matchIntervalMinutes,
        startTime: this.startTime,

        id: this.id
      })
        .then(function(response){
          vm.submitInProgress = false;
          vm.failedSubmit = false;

          //tournament has been created/edited
          vm.$store.dispatch('tournamentChanged', response.data);
        })
        .catch(function(){
          vm.submitInProgress = false;
          vm.failedSubmit = true;
        });

    }
  },

  name: 'edit-tournaments'
}
</script>



<style scoped>

</style>